/** Collapse size variants, while retaining different colours and distinct URLs. */
export function productFamilyKey(product: {productId:string;productUrl?:string}): string {
  if (!product.productUrl) return product.productId;
  try {
    const url = new URL(product.productUrl);
    for (const key of [...url.searchParams.keys()]) {
      if (/^(?:attribute_(?:pa_)?(?:marime|size)|size)$/i.test(key)) url.searchParams.delete(key);
    }
    url.hash = '';
    url.searchParams.sort();
    return url.toString();
  } catch { return product.productId; }
}
